import React, { forwardRef } from 'react';

import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import { GroupedAddon } from './GroupedAddon';

export const GroupTitledInputNumber = forwardRef((props, ref) => {
  const {
    id,
    title = '',
    value,
    onChange,
    readOnly = false,
    disabled = false,
    useGrouping = true,
    suffix = null,
    className = '',
    selectOnFocus = false,
    min,
    max,
    classNameProps,
    variant,
    endAddon,
    ...rest
  } = props;

  const suffixText = suffix ? String(suffix).trim() : '';

  return (
    <div className="p-inputgroup h-full">
      <GroupedAddon
        title={title}
        variant={variant}
        classNameProps={classNameProps}
      />
      <InputNumber
        id={id}
        inputRef={ref}
        className="w-full"
        inputClassName={classNames('w-full text-right ' + className, {
          'bg-gray-100': readOnly && className === '',
          [className]: readOnly && className !== '',
        })}
        readOnly={readOnly}
        disabled={disabled}
        useGrouping={useGrouping}
        value={value}
        onChange={onChange && ((e) => onChange(e.value))}
        onFocus={selectOnFocus ? (e) => e.target.select() : null}
        inputmode="numeric"
        {...(min && { min })}
        {...(max && { max })}
        {...rest}
      />
      {suffixText && (
        <span className="p-inputgroup-addon cm-grouped-suffix">
          {suffixText}
        </span>
      )}
      {endAddon}
    </div>
  );
});

GroupTitledInputNumber.displayName = 'GroupTitledInputNumber';
